import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Row,
  Col,
  Button,
  Form,
  Dropdown,
  ButtonGroup,
  Modal,
  Card,
} from "react-bootstrap";
import { MdAddchart } from "react-icons/md";
import { Link } from "react-router-dom";
import "./hr-info.css";
import { BsFillInfoCircleFill } from "react-icons/bs";
import { CgProfile } from "react-icons/cg";
import { FcOk } from "react-icons/fc";
import { FaEdit } from "react-icons/fa";
import { IoIosEye } from "react-icons/io";

export default function HRInformation() {
  const rowsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showDialog, setShowDialog] = useState(false);
  const [selectedHR, setSelectedHR] = useState(null);
  const [filteredData, setFilteredData] = useState([]); // Store filtered HRs for the table
  const [searchTerm, setSearchTerm] = useState(""); // Store search query

  // Fetch data from backend API
  useEffect(() => {
    const fetchHRs = async () => {
      setLoading(true); // Set loading state before API call
      try {
        const response = await axios.get("https://backend.ems.hiradentallab.com/api/user/hrs");
        const hrData = response.data.data;
        setData(hrData); // Set all HRs data
        setFilteredData(hrData); // Initialize filtered data
        setLoading(false); // Set loading to false after data is fetched
      } catch (error) {
        console.error("Error fetching HRs:", error);
        setLoading(false); // Set loading to false even if there is an error
      }
    };

    fetchHRs();
  }, []);

  // Handle search input change
  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase(); // Get the input value
    setSearchTerm(query); // Update search term

    // Filter the data based on search query
    const filtered = data.filter(
      (hr) =>
        hr.name.toLowerCase().includes(query) || // Search by HR name
        hr.department?.name.toLowerCase().includes(query) // Search by department name
    );

    setFilteredData(filtered); // Update filtered data
  };

  // Prevent default form submission behavior
  const handleFormSubmit = (e) => {
    e.preventDefault();
  };

  // Handle page change
  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= Math.ceil(data.length / rowsPerPage)) {
      setCurrentPage(pageNumber);
    }
  };

  // Calculate page range
  const pageRange = () => {
    const pages = [];
    const totalPages = Math.ceil(data.length / rowsPerPage);
    let startPage = Math.max(currentPage - 1, 1);
    let endPage = Math.min(startPage + 2, totalPages);

    if (endPage - startPage < 2) {
      startPage = Math.max(endPage - 2, 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  const handleShow = (hrData) => {
    setSelectedHR(hrData);
    setShowDialog(true);
  };

  const handleClose = () => setShowDialog(false);

  return (
    <div className="container-fluid">
      <h1 className="emp-info-title">
        <BsFillInfoCircleFill className="settings-icon" /> HR Information
      </h1>
      <hr />
      <h1 className="emp-info-subtitle">
        <CgProfile className="settings-icon" /> HR
      </h1>
      <hr />
      <div className="emp-info-content">
        <Link to="/add-hr">
          <Button variant="primary" className="add-emp-button">
            <MdAddchart className="button-icon" /> Add HR
          </Button>
        </Link>
        <div className="emp-info-actions">
          <Row>
            <Col xs={12} md={6} className="d-flex align-items-center mb-2">
              <Dropdown as={ButtonGroup}>
                <Button variant="primary">Show Entries</Button>
                <Dropdown.Toggle
                  split
                  variant="primary"
                  id="dropdown-split-basic"
                />
                <Dropdown.Menu>
                  <Dropdown.Item href="#/action-1">10</Dropdown.Item>
                  <Dropdown.Item href="#/action-2">25</Dropdown.Item>
                  <Dropdown.Item href="#/action-3">50</Dropdown.Item>
                  <Dropdown.Item href="#/action-4">100</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Col>
            <Col xs={12} md={6} className="d-flex justify-content-end mb-2">
              <div className="search-container">
                <Form className="d-flex" onSubmit={handleFormSubmit}>
                  <Form.Control
                    type="search"
                    placeholder="Search"
                    aria-label="Search"
                    className="emp-info-search"
                    value={searchTerm}
                    onChange={handleSearch} // Call handleSearch on input change
                  />
                </Form>
              </div>
            </Col>
          </Row>
        </div>
        <div className="table-responsive">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <table className="table table-striped table-style">
              <thead className="tablehead">
                <tr className="table-header-footer">
                  <th className="text-center">SR</th>
                  <th className="text-center">User ID</th>
                  <th className="text-center">Employee Name</th>
                  <th className="text-center">Department</th>
                  <th className="text-center">Job Title</th>
                  <th className="text-center">Email</th>
                  <th className="text-center">Gender</th>
                  <th className="text-center">Status</th>
                  <th className="text-center">Salary</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.length > 0 ? (
                  filteredData.map(
                    (
                      hr,
                      index // Define 'index' here as the second parameter of .map()
                    ) => (
                      <tr key={index}>
                        <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                        <td>{hr.userId}</td>
                        <td>{hr.name}</td>
                        <td>{hr.department?.name || "N/A"}</td>
                        <td>{hr.jobTitle || "N/A"}</td>
                        <td>{hr.email}</td>
                        <td>{hr.gender}</td>
                        <td>
                          <FcOk />
                        </td>
                        <td>{hr.salary}</td>
                        <td>
                          <div>
                            <Button
                            style={{marginRight:"5px"}}
                            variant="primary"
                            size="sm"
                              onClick={() => handleShow(hr)}
                            >
                              <IoIosEye />
                            </Button>
                            <Link to={`/edit-hr/${hr.userId}`}>
                              <Button variant="warning"
                              size="sm"
                              style={{marginRight:"5px"}}>
                                <FaEdit />
                              </Button>
                            </Link>
                          </div>
                        </td>
                      </tr>
                    )
                  )
                ) : (
                  <tr>
                    <td colSpan="10">No HR data available</td>
                  </tr>
                )}
              </tbody>

              <tfoot className="table-footer">
                <tr className="emp-info-table-footer">
                  <td>Total</td>
                  <td>-</td>
                  <td>{data.length}</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tfoot>
            </table>
          )}
          <Row className="mt-2">
                      <Col xs={12} md={6} className="d-flex align-items-center">
                        <p className="showing-entries">
                          Showing {(currentPage - 1) * rowsPerPage + 1} to{" "}
                          {Math.min(currentPage * rowsPerPage, data.length)} of{" "}
                          {data.length} entries
                        </p>
                      </Col>
                      <Col xs={12} md={6} className="d-flex justify-content-end">
                        <nav>
                          <ul className="pagination">
                            <li
                              className={`page-item ${
                                currentPage === 1 ? "disabled" : ""
                              }`}
                            >
                              <a
                                href="/#"
                                className="page-link"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handlePageChange(currentPage - 1);
                                }}
                              >
                                Previous
                              </a>
                            </li>
                            {pageRange().map((page) => (
                              <li
                                key={page}
                                className={`page-item ${
                                  currentPage === page ? "active" : ""
                                }`}
                              >
                                <a
                                  href="/#"
                                  className="page-link"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handlePageChange(page);
                                  }}
                                >
                                  {page}
                                </a>
                              </li>
                            ))}
                            <li
                              className={`page-item ${
                                currentPage === Math.ceil(data.length / rowsPerPage)
                                  ? "disabled"
                                  : ""
                              }`}
                            >
                              <a
                                href="/#"
                                className="page-link"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handlePageChange(currentPage + 1);
                                }}
                              >
                                Next
                              </a>
                            </li>
                          </ul>
                        </nav>
                      </Col>
                    </Row>
                  </div>
                </div>

      {/* Modal for displaying employee details */}
      {selectedHR && (
        <Modal show={showDialog} onHide={handleClose} className="custom-modal">
          <Modal.Header
            style={{ backgroundColor: "#004aad", color: "#ffffff" }}
          >
            <Modal.Title style={{ color: "#ffffff" }}>
              Employee Details
            </Modal.Title>
            <button
              onClick={handleClose}
              style={{
                color: "white",
                background: "transparent",
                border: "none",
                fontSize: "50px",
                marginLeft: "50%",
              }}
            >
              &times;
            </button>
          </Modal.Header>
          <Modal.Body>
            {/* Profile Photo Container */}
            <div className="profile-photo-container">
              <h5>Profile Photo</h5>
              {selectedHR.profilePhoto ? (
                <img
                  src={`http://localhost:5544/${selectedHR.profilePhoto}`}
                  alt="Employee Photo"
                  className="employee-photo rounded-photo"
                />
              ) : (
                <p>No profile photo available.</p>
              )}
            </div>

            {/* Employee Info */}
            <div className="employee-info">
              <p>
                <strong>Name:</strong> {selectedHR.name}
              </p>
              <p>
                <strong>Role:</strong> {selectedHR.role}
              </p>
              <p>
                <strong>User ID:</strong> {selectedHR.userId}
              </p>
              <p>
                <strong>User Name:</strong> {selectedHR.username}
              </p>
              <p>
                <strong>Email:</strong> {selectedHR.email}
              </p>
              <p>
                <strong>Department:</strong> {selectedHR.department.name}
              </p>
              <p>
                <strong>Job Title:</strong> {selectedHR.jobTitle}
              </p>
              <p>
                <strong>Salary:</strong> {selectedHR.salary}
              </p>
              <p>
                <strong>Gender:</strong> {selectedHR.gender}
              </p>
              <p>
                <strong>Address:</strong> {selectedHR.address}
              </p>
              <p>
                <strong>Status:</strong> {selectedHR.status}
              </p>
              <p>
                <strong>Join Date:</strong>{" "}
                {new Date(selectedHR.joinDate).toLocaleDateString()}
              </p>
              <p>
                <strong>Birthday According to CNIC:</strong>{" "}
                {new Date(selectedHR.birthday).toLocaleDateString()}
              </p>
              <p>
                <strong>Work Description:</strong> {selectedHR.workDescription}
              </p>
              <p>
                <strong>Work Experience:</strong> {selectedHR.workExperience}
              </p>
            </div>

            {/* Documents Section */}
            <div className="documents-section">
              <Row className="justify-content-end">
                {/* CV Card */}
                <Col xs={12} md={6} className="text-right">
                  <Card className="custom-card">
                    <Card.Body>
                      <h5>CV</h5>
                      {selectedHR.cv ? (
                        <a
                          href={`http://localhost:5544/${selectedHR.cv}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Download CV
                        </a>
                      ) : (
                        <p>No CV available.</p>
                      )}
                    </Card.Body>
                  </Card>
                </Col>

                {/* ID Card Front */}
                <Col xs={12} md={6} className="text-right">
                  <Card className="custom-card">
                    <Card.Body>
                      <h5>ID Card Front</h5>
                      {selectedHR.idCardFront ? (
                        <a
                          href={`http://localhost:5544/${selectedHR.idCardFront}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View ID Card Front
                        </a>
                      ) : (
                        <p>No ID card front available.</p>
                      )}
                    </Card.Body>
                  </Card>
                </Col>

                {/* ID Card Back */}
                <Col xs={12} md={6} className="text-right">
                  <Card className="custom-card">
                    <Card.Body>
                      <h5>ID Card Back</h5>
                      {selectedHR.idCardBack ? (
                        <a
                          href={`http://localhost:5544/${selectedHR.idCardBack}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View ID Card Back
                        </a>
                      ) : (
                        <p>No ID card back available.</p>
                      )}
                    </Card.Body>
                  </Card>
                </Col>

                {/* Work Certificate */}
                <Col xs={12} md={6} className="text-right">
                  <Card className="custom-card">
                    <Card.Body>
                      <h5>Work Certificate</h5>
                      {selectedHR.pastWorkCertificate ? (
                        <a
                          href={`http://localhost:5544/${selectedHR.pastWorkCertificate}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View Work Certificate
                        </a>
                      ) : (
                        <p>No work certificate available.</p>
                      )}
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
}